import router from '@/router/.invoke/router';

export function createNavBarGuard() {
  router.beforeEach((to, from, next) => {
    next();
  });
}
